/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */
/* jshint camelcase: false */

angular.module('bulbApp.assetLibraryModule').service(
  'BulbAssetLibraryService',
  ['ImageCropperDialogService', 'AeroDialogService', 'AnalyticsService', 'AudioCompatibilityService', 'BulbAuthService',
    'BulbBusyCoverService', 'BulbBusyService', 'BulbBrowserService', 'BulbFetchMediaDataService', 'BulbModalService',
    'Restangular', '$interval', '$modalStack', '$q', '$rootScope', '$state', '$timeout', '$translate', '$window', BulbAssetLibraryService,
  ],
);

function BulbAssetLibraryService(
  ImageCropperDialogService,
  AeroDialogService,
  AnalyticsService,
  AudioCompatibilityService,
  BulbAuthService,
  BulbBusyCoverService,
  BulbBusyService,
  BulbBrowserService,
  BulbFetchMediaDataService,
  BulbModalService,
  Restangular,
  $interval,
  $modalStack,
  $q,
  $rootScope,
  $state,
  $timeout,
  $translate,
  $window,
) {

  const that = this;

  // sort key
  this.sortKeys = ['NAME', 'CREDIT', 'TYPE', 'DATE', 'SIZE'];

  this.download = function (entry) {
    const link = document.createElement('a');
    link.href = `${$window.location.href}/${entry.id}/download`;
    link.click();
  };

  // ==============================
  // REST API call
  // ==============================
  const assetlibrary = Restangular.all('assetlibrary');

  this.api = {

    // ==============================
    // account
    // ==============================
    updateAccountPrefs(assetIds) {
      Restangular.one('accounts', BulbAuthService.currentUser.id)
        .patch({ prefs: BulbAuthService.currentUser.prefs }).catch(that.api.errorFn);
    },

    // ==============================
    // all entry type
    // ==============================
    createSearchCondition(folderId, condition, query) {
      return {
        folderId,
        query,
        sortKey: condition.assetLibrarySortKey,
        sortOrderAsc: condition.assetLibrarySortOrderAsc,
        from: condition.from,
        count: condition.count,
        filterImage: condition.typeFilter.IMAGE,
        filterVideo: condition.typeFilter.VIDEO,
        filterAttachedFile: condition.typeFilter.ATTACHED_FILE,
        filterAudio: condition.typeFilter.AUDIO,
        currentPage: condition.currentPage,
        itemsPerPage: condition.itemsPerPage,
      };
    },

    getEntries(folderId, condition) {
      return assetlibrary.get('', that.api.createSearchCondition(folderId, condition))
        .catch(that.api.errorFn);
    },

    search(query, condition) {
      return assetlibrary.get('search', that.api.createSearchCondition(null, condition, query))
        .catch(that.api.errorFn);
    },

    getEntry(entryId) {
      return assetlibrary.one(entryId).get().then((res) => {
        if (res.entry) {
          res.entry.usage = res.usage;
          res.entry.used = res.used;
        }
        return res;
      }, that.api.errorFn);
    },

    moveEntry(entryId, destId) {
      return assetlibrary.one(entryId, 'move').post('', '', {
        folderId: destId,
      }).catch(that.api.errorFn);
    },

    deleteEntry(entry) {
      return assetlibrary.all(entry.id).remove()
        .catch(that.api.errorFn).finally(BulbAuthService.fetchCurrentUser);
    },

    importFromGoogleDrive(
      oauthToken,
      folderId,
      fileId,
      mimeType,
      photoParentId,
      forceAttachedFile,
    ) {
      if ((mimeType.startsWith('application/vnd.google-apps')
        && BulbAuthService.currentUser.prefs.importingGoogleAssetAsPdfEnabled
        && BulbAuthService.currentUser.features.SnapshotPdfFeature.enabled)
        || !mimeType.startsWith('application/vnd.google-apps')) {
        return assetlibrary.all('googledrive').all('import').post('', {
          token: oauthToken,
          mimeType,
          folderId,
          fileId,
          photoParentId,
          forceAttachedFile: !!forceAttachedFile,
        }).catch(that.api.errorFn);
      }
      that.dialog.showError('assetlibrary_googledrive_import_error');

    },

    importFromGooglePhoto(oauthToken, folderId, mediaId) {
      return assetlibrary.all('googledrive').all('import').post('', {
        token: oauthToken,
        folderId,
        mediaId,
        googlePhoto: true,
      }).catch(that.api.errorFn);
    },

    errorFn(res) {
      if (res.data && (res.data.message || res.data.developerMessage)) {
        const errorMessage = (res.data.message ? res.data.message : res.data.developerMessage);
        if (errorMessage === 'error_storage_size_exceeded') {
          that.dialog.dismissAllModals();
          that.dialog.showStorageSizeExceedError();
        } else {
          that.dialog.showError(errorMessage);
        }
      } else {
        that.dialog.showError('unknown_error');
      }
    },

    // ==============================
    // folder entry
    // ==============================
    createFolder(entry) {
      return assetlibrary.all('folder').post({
        folderId: entry.folderId,
        name: entry.name,
      }).catch(that.api.errorFn);
    },

    updateFolder(entry) {
      return assetlibrary.one('folder', entry.id).patch({
        name: entry.name,
      }).catch(that.api.errorFn);
    },

    // ==============================
    // image entry
    // ==============================
    createImage(folderId, entry) {
      return assetlibrary.all('image').post({
        folderId,
        name: entry.name,
        credit: entry.credit,
        fileSize: entry.fileSize,
      }).catch(that.api.errorFn).finally(BulbAuthService.fetchCurrentUser);
    },

    updateImage(entry) {
      return assetlibrary.one('image', entry.id).patch({
        name: entry.name,
        credit: entry.credit,
        rotationDegree: entry.rotationDegree,
      }).catch(that.api.errorFn);
    },

    crop(entry) {
      return assetlibrary.one('image', entry.id).all('crop').patch({
        cropRect: entry.cropRect,
      }).catch(that.api.errorFn);
    },

    // ==============================
    // video entry
    // ==============================
    createVideo(folderId, entry) {
      return assetlibrary.all('video').post({
        folderId,
        name: entry.name,
        credit: entry.credit,
        fileSize: entry.fileSize,
      }).catch(that.api.errorFn).finally(BulbAuthService.fetchCurrentUser);
    },

    createExternalServiceVideo(folderId, videoUrl, fromAssetLibrary = false) {
      return assetlibrary.all('video/externalservice').post({
        folderId,
        videoUrl,
        fromAssetLibrary,
      });
    },

    updateVideo(entry) {
      return assetlibrary.one('video', entry.id).patch({
        name: entry.name,
        credit: entry.credit,
        selectedSplashImageId: (entry.selectedSplashImageId) ? entry.selectedSplashImageId : entry.video.splashImageId,
        jspType: entry.video.jspType,
      }).catch(that.api.errorFn);
    },

    // ==============================
    // attached file entry
    // ==============================
    createAttachedFile(folderId, entry) {
      return assetlibrary.all('attachedFile').post({
        folderId,
        name: entry.name,
        credit: entry.credit,
        fileSize: entry.fileSize,
      }).catch(that.api.errorFn).finally(BulbAuthService.fetchCurrentUser);
    },

    updateAttachedFile(entry) {
      return assetlibrary.one('attachedFile', entry.id).patch({
        name: entry.name,
        credit: entry.credit,
      }).catch(that.api.errorFn);
    },

    // ==============================
    // audio file entry
    // ==============================
    createAudio(folderId, entry) {
      return assetlibrary.all('audio').post({
        folderId,
        name: entry.name,
        credit: entry.credit,
        fileSize: entry.fileSize,
      }).catch(that.api.errorFn).finally(BulbAuthService.fetchCurrentUser);
    },

    updateAudio(entry) {
      return assetlibrary.one('audio', entry.id).patch({
        name: entry.name,
        credit: entry.credit,
      }).catch(that.api.errorFn);
    },

  };

  // ==============================
  // dialog
  // ==============================
  const currentErrorDialog = {};

  this.dialog = {

    modalOptions: {
      titleCode: '',
      showOkButton: false,
      showCancelButton: false,
      windowClass: 'bulb-assetlibrary-modal',
      controller: ['$scope', function ($scope) {
        $scope.assetLibraryService = that;
      }],
    },

    setDefaultFocusInModal() {
      const topModalElement = BulbModalService.getTopModalElement();
      if (!topModalElement) {
        return;
      }

      const buttons = topModalElement.find('.bulb-modal-body').eq(0).find('button:last');
      if (buttons.length) {
        buttons.focus();
        return;
      }

      const closeBtn = topModalElement.find('.bulb-modal-body').parent().eq(0).find('.reveal-modal-close')
        .children()
        .eq(0);
      closeBtn.focus();
    },

    // open modal dialog
    show(options, onOpened) {
      const modal = BulbModalService.open(options);
      if (onOpened) {
        modal.opened.then(onOpened);
      }

      modal.opened.then(() => {
        $timeout(() => {
          that.dialog.setDefaultFocusInModal();
        }, 1);
      });

      return modal.result;
    },

    // close the current modal dialog
    closeCurrentModal() {
      const top = $modalStack.getTop();
      console.log($modalStack, top);
      if (top) {
        $modalStack.close(top.key);
      }
    },
    // close the current modal dialog on keypress
    closeCurrentModalKeyPress(event) {
      BulbModalService.clearDialog(event);
    },

    // dismiss the all modal dialog
    dismissAllModals() {
      $modalStack.dismissAll();
    },

    // message modal
    showMessage(srcOptions, key, args) {
      let tmpMessage;
      $translate(key, args).then(
        (message) => {
          tmpMessage = message;
        },
      );

      const options = angular.extend({}, that.dialog.modalOptions, srcOptions);
      options.templateUrl = 'assetlibrary.message';
      options.windowClass = options.windowClass;
      options.controller = ['$scope', function ($scope) {
        $scope.message = tmpMessage;
      }];
      return that.dialog.show(options);
    },

    // error modal
    showError(key, args) {
      // Specific image HEIC error alert:
      if (key.split('.').pop().toLowerCase() === 'heic') {
        that.dialog.showImageHEICUnsupportedError();
      } else {
        $translate(key, args).then(
          (message) => {
            if (currentErrorDialog[key]) {
              return;
            }
            currentErrorDialog[key] = true;
            const modalOptions = {
              titleCode: 'server_error_title',
              fontAwesomeCode: 'fas fa-exclamation-triangle',
              bodyCode: message,
              showOkbutton: true,
              showCancelButton: true,
              windowClass: key === 'assetlibrary_googledrive_import_error'
                ? 'updated-modal-design bulb-snapshot-pdf' // jshint ignore:line
                : 'updated-modal-design',
            };
            BulbModalService.show(modalOptions).finally(() => {
              currentErrorDialog[key] = null;
            });
          },
        );
      }
    },

    // unsupported file format error
    showUnsupportedFileFormatError(messageCode) {
      const modalOptions = {
        titleCode: 'server_error_title',
        fontAwesomeCode: 'fas fa-exclamation-triangle',
        bodyCode: messageCode,
        showOkbutton: true,
        showCancelButton: false,
        windowClass: 'updated-modal-design bulb-aero-modal bulb-onedrive-embed-modal',
      };
      BulbModalService.show(modalOptions);
    },

    // Image heic unsupported modal:
    showImageHEICUnsupportedError() {
      const modalOptions = {
        titleCode: 'modal_image_heic_warning',
        templateUrl: 'imageheicalert.nested',
        fontAwesomeCode: 'fas fa-exclamation-triangle',
        okButtonCode: 'onboarding_got_it_button',
        windowClass: 'updated-modal-design image-heic-alert',
      };
      BulbModalService.show(modalOptions);
    },

    // file size exceeded error
    showFileSizeExceedError() {
      that.dialog.showError('upload_error_size_exceeded');
    },

    // storage size exceeded error
    showStorageSizeExceedError() {
      const data = { detail: $translate.instant('error_storage_size_exceeded') };
      AeroDialogService.showPlanUpgradeDialog(data);

    },

    // User not authorized feature
    showUnauthorizedError() {
      that.dialog.showError('error_file_upload_user_not_authorized');
    },

    // all entry

    // delete dialog
    showDeleteEntryDialog(event, srcEntry, onOkFn) {

      BulbBusyCoverService.showBusyDuring(
        that.api.getEntry(srcEntry.id).then((response) => {
          const { entry } = response;

          const options = {};
          options.showOkButton = true;
          options.focusAfterClosed = event.currentTarget;
          if (entry.type === 'FOLDER') {
            // folder
            if (entry.used) {
              // this asset is used
              options.okButtonCode = 'button_ok';
              that.dialog.showMessage(options, 'assetlibrary_can_not_delete_folder');
              return;
            }

          } else {
            // not folder
            if (entry.usage.collections.length > 0) {
              // this asset is used
              options.okButtonCode = 'button_ok';
              that.dialog.showMessage(options, 'assetlibrary_can_not_delete_asset');
              return;
            }
          }

          options.okButtonCode = 'button_delete';

          that.dialog.showMessage(
            options,
            'assetlibrary_delete_asset_dialog_label',
            { name: entry.name },
          ).then(() => {

            const deferred = $q.defer();
            BulbBusyCoverService.showBusyDuring(deferred.promise);

            that.dialog.dismissAllModals();
            $timeout(() => {
              $rootScope.$apply();
              that.api.deleteEntry(entry).then(() => {
                if (onOkFn) {
                  onOkFn();
                }
                deferred.resolve();
              }, deferred.reject);
            }, 1);
          });
        }),
      );
    },

    // select handler for entry
    processSelectHandler(entry) {
      // Dismiss all modal immediately after item is selected.
      if (that.selectHandler.name === 'bound imageCarouselSelectHandler') {
        BulbBusyCoverService.showBusyDuring(that.selectHandler(entry)).then(that.dialog.dismissAllModals);
      } else if (that.selectHandler) {
        // Dismiss all modal immediately after item is selected.
        that.dialog.dismissAllModals();

        // wait to finish closing modal process before handling the selected file.
        $timeout(() => {
          BulbBusyCoverService.showBusyDuring(that.selectHandler(entry));
        }, 300);
      }
    },

    /**
     * FUTURE CLEAN : Not happy with this 'implementation' of the drag and drop with our new upload workflow however
     * due to the current timeline and the push to get this out, it will have to due.
     *
     * Ideally, I would absolutely love to use Uppy's Drag & Drop plugin. I would have to come back and
     * implement that later.
     * ^^ https://bulbapp.atlassian.net/browse/BULBAPP-1273
     */
    // init drag and drop uploader
    // eslint-disable-next-line no-underscore-dangle
    _initDragAndDropUploader(
      dragAndDropUploaderOption,
      attr,
      isImageCarouselDragAndDrop,
      avatarOrCoverImageUploadState,
      fromWithinAssetLibrary,
    ) {
      // inline helper methods:
      const showUploadTabDragArea = function () {
        $('#assetlibrary-file-drop-area-cover').show();
      };

      const hideUploadTabDragArea = function () {
        $('#assetlibrary-file-drop-area-cover').hide();
      };

      let dropZone;
      // To avoid the duplicate id while fast pass the id's for the attached-file <div> is diffrerent and rest
      // is different so adding this if/else check to identify the same.
      if (attr) {
        dropZone = '#assetlibrary-file-drop-area-second';
      } else {
        dropZone = '#assetlibrary-file-drop-area';
      }

      if (fromWithinAssetLibrary) {
        jQuery(dropZone).on('dragover', showUploadTabDragArea);
        jQuery('#assetlibrary-file-drop-area-cover').on('dragleave', hideUploadTabDragArea);

      }

      var watchForDragElement = $interval(() => {
        const fileDropArea = $(dropZone);
        if (fileDropArea[0]) {
          $interval.cancel(watchForDragElement);
          $(dropZone).bind('drop', (event) => {
            // Prevent default behavior (Prevent file from being opened)
            event.preventDefault();
            if (event.originalEvent.dataTransfer.items) {
              // Use DataTransferItemList interface to access the file(s)
              // Should really only be one file for us now, since we don't allow / support multi-file upload, yet.
              for (let i = 0; i < event.originalEvent.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (event.originalEvent.dataTransfer.items[i].kind === 'file') {
                  const file = event.originalEvent.dataTransfer.items[i].getAsFile();
                  //  default upload state:
                  let uploadState = 'draganddrop';
                  if (avatarOrCoverImageUploadState) {
                    uploadState = avatarOrCoverImageUploadState;
                  } else if (isImageCarouselDragAndDrop) {
                    uploadState = 'pageImageCarousel';
                  }
                  const initDragAndDropEvent = new CustomEvent('initDragAndDrop', {
                    detail: {
                      file,
                      attr: (attr) || '*',
                      fromWithinAssetLibrary: !!(fromWithinAssetLibrary),
                      uploadState,
                    },
                  });
                  $window.dispatchEvent(initDragAndDropEvent);
                }
              }
            }
          });
        }
      }, 100);
    },

    // show detail modal
    showDetailModal(assetContainerCtrl, entry) {
      const options = angular.extend({}, that.dialog.modalOptions);
      options.templateUrl = 'assetlibrary.detail.edit';
      options.windowClass += ' bulb-assetlibrary-detail-modal bulb-assetlibrary-modal-no-footer';
      options.controller = ['$scope', function ($scope) {
        $scope.assetLibraryService = that;
        $scope.assetContainerCtrl = assetContainerCtrl;
      }];
      options.focusAfterClosed = entry.focusAfterClosed;
      const showDialogHandler = function () {
        that.dialog.show(options).then(() => {
          assetContainerCtrl.updateTargetEntry();
        });
      };

      if (entry.id) {
        BulbBusyCoverService.showBusyDuring(
          that.api.getEntry(entry.id).then((response) => {
            assetContainerCtrl.targetEntry = response.entry;
            showDialogHandler();
          }),
        );
      } else {
        showDialogHandler();
      }
    },

    // image entry
    image: {

      // show crop dialog
      showCropDialog(entry, saveHandler) {

        const options = angular.extend({}, that.dialog.modalOptions);
        options.templateUrl = 'ajs/assetlibrary/modal/assetlibrary-crop-modal.html';
        options.windowClass += ' bulb-assetlibrary-modal-crop bulb-assetlibrary-modal-no-footer';
        options.controller = ['$scope', function ($scope) {
          $scope.assetLibraryService = that;
          $scope.entry = entry;
          $scope.saveHandler = saveHandler;
        }];

        $modalStack.dismissAll();
        ImageCropperDialogService.show(entry.image, false, saveHandler, 'FREEFORM', 465, 300);
      },

      /**
       * Show the image selection modal for uploading / selecting an image on a ***page***.
       *
       * @param selectHandler Function callback reference that selects the current entry from the assetlibrary.
       * @param openFileSelectHandler Function callback reference that handles uploads from local file system.
       * @param importGoogleDriveItemHandler Function callback reference that handles uploads from google drive.
       * @param googlePhotoHandler Function callback reference that handles uploads from google photos.
       * @param unsplashPhotoHandler Function callback reference that handles uploads from Unsplash.
       * @param importOneDriveItemHandler Function callback reference that uploads from MS OneDrive.
       * @param dragAndDropUploaderOption Function callback reference that handles drag and drop uploads.
       * @param imageCarouselDragAndDrop Boolean indicating if the drag and drop asset is in the context of an image
       * carousel.
       *
       * @returns { * }
       */
      showSelectionModal(
        selectHandler,
        openFileSelectHandler,
        importGoogleDriveItemHandler,
        googlePhotoHandler,
        unsplashPhotoHandler,
        importOneDriveItemHandler,
        dragAndDropUploaderOption,
        imageCarouselDragAndDrop,
        avatarOrCoverImageUploadState,
        focusAfterClosed,
      ) {

        that.selectHandler = selectHandler;

        const options = angular.extend({}, that.dialog.modalOptions);
        options.templateUrl = 'ajs/assetlibrary/modal/assetlibrary-selection-modal.html';
        options.titleCode = 'assetlibrary_modal_use_image_title';
        options.windowClass = 'bulb-assetlibrary-selection-modal bulb-assetlibrary-modal-no-footer';
        options.controller = ['$scope', function ($scope) {
          $scope.assetLibraryService = that;
          $scope.assetType = 'IMAGE';
          $scope.uploadFileHandler = openFileSelectHandler;
          $scope.importGoogleDriveItemHandler = importGoogleDriveItemHandler;
          $scope.googlePhotoHandler = googlePhotoHandler;
          $scope.unsplashPhotoHandler = unsplashPhotoHandler;
          $scope.importOneDriveItemHandler = importOneDriveItemHandler;
        }];
        options.focusAfterClosed = focusAfterClosed;

        return that.dialog.show(options, () => {
          // drag and drop uploader
          if (dragAndDropUploaderOption) {
            that.dialog._initDragAndDropUploader(
              dragAndDropUploaderOption,
              'image/*',
              imageCarouselDragAndDrop,
              avatarOrCoverImageUploadState,
            );
          }
        });
      },

      // show Edit profile image modal
      showEditProfileImageModal(avatar, saveHandler) {

        const options = angular.extend({}, that.dialog.modalOptions);
        options.templateUrl = 'ajs/assetlibrary/modal/assetlibrary-crop-modal.html';
        options.windowClass = 'bulb-assetlibrary-modal-crop bulb-assetlibrary-modal-no-footer';
        options.controller = ['$scope', function ($scope) {
          $scope.assetLibraryService = that;
          $scope.entry = avatar;
          $scope.saveHandler = saveHandler;
          $scope.fromProfileImageSelection = true;
        }];
        options.titleCode = 'update_avatar_image';

        ImageCropperDialogService.show(avatar, true, saveHandler, 'CIRCULAR');

      },

    },

    // video entry
    video: {

      // show 'add a video' modal
      showAddDialog(assetContainerCtrl, focusAfterClosed) {

        const options = angular.extend({}, that.dialog.modalOptions);
        options.templateUrl = 'assetlibrary.video.add';
        options.windowClass += ' bulb-assetlibrary-modal-no-footer';
        options.controller = ['$scope', function ($scope) {
          $scope.assetLibraryService = that;
          $scope.assetContainerCtrl = assetContainerCtrl;
        }];
        options.focusAfterClosed = focusAfterClosed;
        that.dialog.show(options);
      },

      // show selection modal
      showSelectionModal(
        selectHandler,
        openFileSelectHandler,
        importGoogleDriveItemHandler,
        googlePhotoHandler,
        createExternalServiceVideoHandler,
        importOneDriveItemHandler,
        dragAndDropUploaderOption,
        focusAfterClosed,
      ) {

        that.selectHandler = selectHandler;

        const options = angular.extend({}, that.dialog.modalOptions);
        options.templateUrl = 'ajs/assetlibrary/modal/assetlibrary-selection-modal.html';
        options.titleCode = 'assetlibrary_modal_use_video_title';
        options.windowClass = 'bulb-assetlibrary-selection-modal bulb-assetlibrary-modal-no-footer';
        options.controller = ['$scope', function ($scope) {
          $scope.assetLibraryService = that;
          $scope.assetType = 'VIDEO';
          $scope.uploadFileHandler = openFileSelectHandler;
          $scope.importGoogleDriveItemHandler = importGoogleDriveItemHandler;
          $scope.googlePhotoHandler = googlePhotoHandler;
          $scope.createExternalServiceVideoHandler = createExternalServiceVideoHandler;
          $scope.importOneDriveItemHandler = importOneDriveItemHandler;
        }];
        options.focusAfterClosed = focusAfterClosed;
        return that.dialog.show(options, () => {
          // drag and drop uploader
          that.dialog._initDragAndDropUploader(dragAndDropUploaderOption, 'video/*');
        });
      },
    },

    // attached file entry
    attachedFile: {

      // show selection modal
      showSelectionModal(
        selectHandler,
        openFileSelectHandler,
        importGoogleDriveItemHandler,
        importOneDriveItemHandler,
        dragAndDropUploaderOption,
        focusAfterClosed,
      ) {

        that.selectHandler = selectHandler;

        const options = angular.extend({}, that.dialog.modalOptions);
        options.templateUrl = 'ajs/assetlibrary/modal/assetlibrary-selection-modal.html';
        options.titleCode = 'assetlibrary_modal_use_attached_file_title';
        options.windowClass = 'bulb-assetlibrary-selection-modal bulb-assetlibrary-modal-no-footer';
        options.controller = ['$scope', function ($scope) {
          $scope.assetLibraryService = that;
          $scope.assetType = 'ATTACHED_FILE';
          $scope.importGoogleDriveItemHandler = importGoogleDriveItemHandler;
          $scope.uploadFileHandler = openFileSelectHandler;
          $scope.importOneDriveItemHandler = importOneDriveItemHandler;
        }];
        options.focusAfterClosed = focusAfterClosed;
        return that.dialog.show(options, () => {
          // drag and drop uploader
          that.dialog._initDragAndDropUploader(dragAndDropUploaderOption);
        });
      },
    },

    // audio entry
    audio: {

      // show 'add an audio' modal
      showAddDialog(assetContainerCtrl) {

        const options = angular.extend({}, that.dialog.modalOptions);
        options.templateUrl = 'assetlibrary.audio.add.nested';
        options.windowClass += ' bulb-assetlibrary-modal-no-footer';
        options.controller = ['$scope', function ($scope) {
          $scope.assetLibraryService = that;
          $scope.assetContainerCtrl = assetContainerCtrl;
        }];

        that.dialog.show(options);
      },

      // show selection modal
      showSelectionModal(
        selectHandler,
        openFileSelectHandler,
        importGoogleDriveItemHandler,
        importOneDriveItemHandler,
        dragAndDropUploaderOption,
        fromWithinAssetlibrary,
        focusAfterClosed,
      ) {

        that.selectHandler = selectHandler;
        that.dragAndDropUploaderOption = dragAndDropUploaderOption;

        const options = angular.extend({}, that.dialog.modalOptions);
        options.templateUrl = 'ajs/assetlibrary/modal/assetlibrary-selection-modal.html';
        options.titleCode = 'assetlibrary_modal_use_audio_title';
        options.windowClass = (!fromWithinAssetlibrary)
          ? 'bulb-assetlibrary-selection-modal bulb-assetlibrary-modal-no-footer'
          : 'bulb-assetlibrary-selection-modal bulb-assetlibrary-modal-no-footer bulb-audio-assetlibrary-modal';
        options.controller = ['$scope', function ($scope) {
          $scope.assetLibraryService = that;
          $scope.assetType = 'AUDIO';
          $scope.fromWithinAssetlibrary = fromWithinAssetlibrary;
          $scope.uploadFileHandler = openFileSelectHandler;
          $scope.isMobile = BulbBrowserService.isIOSMobile() || BulbBrowserService.isAndroid();
          $scope.importGoogleDriveItemHandler = importGoogleDriveItemHandler;
          $scope.importOneDriveItemHandler = importOneDriveItemHandler;
          $scope.recordAudio = function (event) {
            event.preventDefault();
            const audioCaptureEventObject = {
              event: 'AudioCapture',
              browser: AudioCompatibilityService.browserDetails().name,
              OS: AudioCompatibilityService.osName(),
            };

            // Get the focusable element inside the custom aero-button component
            const focusableTarget = event.currentTarget;

            // Perform an initial check to see whether or not the browser or device the user is using
            // Supports Audio Capture:
            if (!AudioCompatibilityService.isWebRTCSupported
              || (AudioCompatibilityService.isChromeBrowser()
                && (BulbBrowserService.isIOSMobile() || BulbBrowserService.isIpad()))) {
              // Push event to our GTM:
              AnalyticsService.pushEvent(audioCaptureEventObject);
              const modalOptions = {
                titleCode: 'modal_audio_capture_warning',
                bodyCode: 'audio_capture_compatibility_body',
                fontAwesomeCode: 'fas fa-exclamation-triangle',
                windowClass: 'updated-modal-design audio-compatibility-modal',
                focusAfterClosed: focusableTarget,
              };
              BulbModalService.show(modalOptions);
            } else if (AudioCompatibilityService.isSafariBrowser()
                 && (BulbBrowserService.isIOSMobile() || BulbBrowserService.isIpad())) {
              // Push event to our GTM:
              AnalyticsService.pushEvent(audioCaptureEventObject);
              // If the user is using iOS Safari, lets inform the user of our app within the App-Store. We
              // Also inform them that using ***desktop*** Chrome of Safari would work.
              const modalOptionsiOS = {
                titleCode: 'modal_audio_external_audioinput_alert',
                templateUrl: 'audiocaptureiosalert.nested',
                okButtonCode: 'update_agreement_button',
                fontAwesomeCode: 'fas fa-exclamation-triangle',
                windowClass: 'updated-modal-design audio-capture-iOS-Safari-alert',
                focusAfterClosed: focusableTarget,
              };
              BulbModalService.show(modalOptionsiOS);
            } else if (AudioCompatibilityService.isSafariBrowser()) {
              // Push event to our GTM:
              AnalyticsService.pushEvent(audioCaptureEventObject);
              BulbFetchMediaDataService.isUsingExternalAudioInputDevice(true)
                .then((isUsingExternalAudioInputDevice) => {
                  if (isUsingExternalAudioInputDevice) {
                    const modalOptions = {
                      titleCode: 'modal_audio_external_audioinput_alert',
                      bodyCode: 'audio_capture_external_audioinput_body',
                      okButtonCode: 'update_agreement_button',
                      fontAwesomeCode: 'fas fa-exclamation-triangle',
                      windowClass: 'updated-modal-design audio-safari-external-audioinput-alert',
                      focusAfterClosed: focusableTarget,
                    };
                    BulbModalService.show(modalOptions).then(() => {
                      // Reload of state to update audioinput devices data:
                      $state.reload();
                    });
                  } else {
                    // Proceed with normal audio capture flow:
                    that.dialog.closeCurrentModal();
                    const ref = AeroDialogService.showAudioRecordingDialog(true, fromWithinAssetlibrary);
                    ref.onClose.subscribe(() => {
                      // Re-open the Add Audio Assetlibrary Selection dialog:
                      that.dialog.audio.showSelectionModal(
                        that.selectHandler,
                        $scope.uploadFileHandler,
                        $scope.importGoogleDriveItemHandler,
                        $scope.importOneDriveItemHandler,
                        that.dragAndDropUploaderOption,
                        false,
                        null,
                      );
                    });
                    BulbModalService.setAccessibilityOnDialog(focusableTarget);
                  }
                }, (error) => {
                  console.log('error retrieving audio input devices from user.', error);
                });
            } else {
              // Push event to our GTM:
              AnalyticsService.pushEvent(audioCaptureEventObject);
              // In every other case, just perform audio capture normally:
              that.dialog.closeCurrentModal();
              const ref = AeroDialogService.showAudioRecordingDialog(true, fromWithinAssetlibrary);
              ref.onClose.subscribe(() => {
                // Re-open the Add Audio Assetlibrary Selection dialog:
                that.dialog.audio.showSelectionModal(
                  that.selectHandler,
                  $scope.uploadFileHandler,
                  $scope.importGoogleDriveItemHandler,
                  $scope.importOneDriveItemHandler,
                  that.dragAndDropUploaderOption,
                  false,
                  null,
                );
              });
              BulbModalService.setAccessibilityOnDialog(focusableTarget);
            }
          };
        }];
        options.focusAfterClosed = focusAfterClosed;
        return that.dialog.show(options, () => {
          // drag and drop uploader
          that.dialog._initDragAndDropUploader(
            that.dragAndDropUploaderOption,
            'audio/*',
            false,
            false,
            fromWithinAssetlibrary,
          );
        });
      },

    },

    // only show the Asset Library tab
    onlyAssetLibrary: {

      showSelectionModal(onSelect, assetType) {
        that.selectHandler = onSelect;
        const asset = assetType || 'IMAGE';
        const options = angular.extend({}, that.dialog.modalOptions);
        options.templateUrl = 'ajs/assetlibrary/modal/assetlibrary-selection-modal--only-asset-library.html';
        options.titleCode = `assetlibrary_modal_use_${asset.toLowerCase()}_title`;
        options.windowClass = 'bulb-assetlibrary-selection-modal bulb-assetlibrary-modal-no-footer';
        options.controller = ['$scope', function ($scope) {
          $scope.assetLibraryService = that;
          $scope.assetType = assetType;
          $scope.uploadFileHandler = onSelect;
        }];
        return that.dialog.show(options);
      },
    },
  };

  // TODO POLISH : we might want to monitor the play/pause events of the
  // video players, so we don't show the
  // blue play button on top of a playing video.
  this.playVideo = function (entry, videoPlayerStyleId) {
    if (entry.video.jspType === 'VIMEO') {
      if (that.vimeoPlayer) {
        that.vimeoPlayer.api('paused', (isPaused, playerId) => {
          if (isPaused) {
            that.vimeoPlayer.api('play');
          } else {
            that.vimeoPlayer.api('pause');
          }
        });
      }
    } else {

      $rootScope.$broadcast('bulb-video-play-toggle', 'assetlibrary-detail-modal-player');
      const $player = $(`#${videoPlayerStyleId}`);
      $player.children('.overlay').hide();
      $player.find('.jw-controls').show();

    }
  };

}
